// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2mXm7","col":"styles_col__1NWUp","fulfillmentStatus":"styles_fulfillmentStatus__2DydH","emailCol":"styles_emailCol__3_3Rt"};